import { useState } from "react";
import { hotRanks } from "../../../mocks/baogua";

const tabs = ["全部", "娱乐", "消费", "职场", "科技", "生活", "社会", "旅行"];

export default function FeedList() {
  const [active, setActive] = useState("全部");
  const items = active === "全部" ? hotRanks : hotRanks.filter((it) => it.category === active);

  return (
    <section id="feed" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-8">
        <div>
          <h2 className="font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a]">
            最新爆料流
          </h2>
          <p className="mt-3 text-[#201d1a]/60">按分类快速切换，追你想追的瓜，讨论区实时滚动更新。</p>
        </div>
        <div className="inline-flex flex-wrap gap-1.5">
          {tabs.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                active === t
                  ? "bg-emerald-600 text-white font-medium"
                  : "bg-white border border-amber-900/10 text-[#201d1a]/70 hover:border-emerald-600/40"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <article
            key={item.id}
            className="group overflow-hidden rounded-2xl bg-white border border-amber-900/10 hover:border-emerald-600/30 transition-colors cursor-pointer"
          >
            <div className={`relative h-32 bg-gradient-to-br ${item.gradient} overflow-hidden`}>
              <i className={`${item.icon} absolute -right-2 -bottom-3 w-24 h-24 text-white/20 flex items-center justify-center`}></i>
              <i className={`${item.icon} absolute left-4 top-4 text-white w-7 h-7 flex items-center justify-center`}></i>
              {item.badge && (
                <span className="absolute left-4 bottom-3 rounded-md bg-white/95 px-2 py-0.5 text-xs font-bold text-[#ff4d3d]">
                  {item.badge}
                </span>
              )}
              <span className="absolute right-3 top-3 rounded-full bg-black/15 text-white text-xs px-2.5 py-1">
                {item.category} · {item.time}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="font-semibold text-[#201d1a] leading-snug group-hover:text-emerald-700 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-[#201d1a]/55 line-clamp-2">{item.excerpt}</p>
              <div className="mt-4 pt-3 border-t border-amber-900/5 flex items-center justify-between text-xs text-[#201d1a]/50 flex-wrap gap-2">
                <span className="flex items-center gap-1"><i className="ri-fire-fill w-4 h-4 flex items-center justify-center text-orange-400"></i>{item.heat}</span>
                <span className="flex items-center gap-1"><i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>{item.comments.toLocaleString()}</span>
                <span className="flex items-center gap-1"><i className="ri-heart-3-line w-4 h-4 flex items-center justify-center"></i>{item.likes.toLocaleString()}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>围观中</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}